var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddressPinOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.028 21.474l.047-.027c.987-.565 3.017-1.944 4.78-3.932C18.625 15.52 20 13.056 20 10.28c0-4.264-3.549-7.78-8-7.78-4.452 0-8 3.516-8 7.78 0 2.776 1.376 5.24 3.145 7.235 1.763 1.988 3.793 3.367 4.78 3.932l.047.027.028.018.028-.018zm.792 1.274a1.463 1.463 0 01-1.64 0C9 21.5 2.5 16.85 2.5 10.28 2.5 5.155 6.753 1 12 1s9.5 4.155 9.5 9.28c0 6.57-6.5 11.22-8.68 12.468z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 10.5a2 2 0 11-4 0 2 2 0 014 0z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressPinOutline);
export default __webpack_public_path__ + "static/media/AddressPinOutline.c145106f067f6653d4f81c2c59a9b704.svg";
export { ForwardRef as ReactComponent };